import styled from 'styled-components';

export const GroupItem = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(1)};
  min-width: 0;
  max-width: 100%;
  margin-right: 2px;

  &:not(:first-child) {
    margin-left: ${({ theme }) => theme.spacing(1)};
  }
`;

export const GroupAvatar = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  flex-shrink: 0;
  background: ${({ theme }) => theme.tint.primary.medium};
  color: ${({ theme }) => theme.palette.info.dark};

  /* Out-specify the grid's own .MuiSvgIcon-fontSizeMedium { 24px } rule, which only bites in-row
     (the overflow popover portals outside the grid root). */
  svg.MuiSvgIcon-root {
    font-size: 14px;
  }
`;

// A span, not a p: the grid list renderer and its overflow popover both style bare `p` children.
export const GroupName = styled.span`
  font-size: 14px;
  line-height: 16px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
